import type {
  ExtractedFileData,
  NotificationDecisionTransformResult,
} from "../types";

const CATEGORY_CODE_MAP: Record<string, string> = {
  EE: "ESSENTIAL",
  EI: "IMPORTANT",
};

export function transformNotificationDecision(
  extracted: ExtractedFileData
): NotificationDecisionTransformResult {
  const raw: Record<string, unknown> = {};
  for (const [key, field] of Object.entries(extracted.fields)) {
    raw[key] = field.parsedValue;
  }

  const str = (field: string): string | null => {
    const val = extracted.fields[field]?.parsedValue;
    return typeof val === "string" ? val : null;
  };

  const sectors = extracted.fields.sectors?.parsedValue;
  const categoryCode = str("categoryCode");

  return {
    decisionNumber: str("decisionNumber"),
    decisionDate: str("decisionDate"),
    entityName: str("entityName"),
    address: str("address"),
    county: str("county"),
    cui: str("cui"),
    category: CATEGORY_CODE_MAP[categoryCode ?? ""] ?? str("category"),
    categoryCode,
    registrationNumber: str("registrationNumber"),
    sectors: Array.isArray(sectors) ? sectors : [],
    raw,
  };
}
